<script>
  import { apiFetch } from "../../lib/api.js";
  import { user } from "../../stores/user";
  import { BASE_URL } from "../../stores/BASE_URL";
  import { onMount } from "svelte";
  import { navigate } from "svelte-routing";
  import Alert from "../Alert.svelte";

  export let id_usuario = 0;

  let api = {
    id_usuario: id_usuario,
    api_key: "",
  };

  let acciones = false;
  let updating = false;

  let alert = {
    show: false,
    message: "",
    status: "",
    time: 3000,
  };

  const getUsuarioApi = async () => {
    const response = await apiFetch(`${BASE_URL}usuario.php?action=getUsuarioApi&id=${id_usuario}`);
    const resp = await response.json();
    if (resp.status == "success") {
      api = resp.data;
    }
  };

  const actualizarUsuarioApi = async () => {
    updating = true;
    alert.show = false;

    const formData = new FormData();
    formData.append("id_usuario", id_usuario);
    formData.append("action", "setUsuarioApi");
    formData.append("api_key", api.api_key);
    formData.append("session_id_usuario", $user.idUsuario);
    const response = await apiFetch(`${BASE_URL}usuario.php`, {
      method: "POST",
      body: formData,
    });
    const resp = await response.json();
    if (resp.status == "success") {
      alert.show = true;
      alert.message = "Datos actualizados";
      alert.status = "success";
    } else {
      alert.show = true;
      alert.message = "Error al actualizar los datos";
      alert.status = "danger";
    }
    updating = false;
  };

  onMount(() => {
    if (!$user) {
      navigate("/", { replace: true });
    }

    getUsuarioApi();

    if ($user.rol == "administrador" || $user.rol == "operaciones") {
      acciones = true;
    }
  });
</script>

<div class="row g-2">
  <div class="col-12 col-md-6 col-lg-8">
    <input type="text" class="form-control" bind:value={api.api_key} />
  </div>
  <div class="col-12 col-md-6 col-lg-4">
    {#if updating}
      <button class="btn btn-primary disabled"> Actualizando... </button>
    {:else}
      <button class="btn btn-primary" on:click={actualizarUsuarioApi}> Actualizar </button>
    {/if}
  </div>
</div>

{#if alert.show}
  <div class="mt-2">
    <Alert message={alert.message} status={alert.status} time={alert.time} />
  </div>
{/if}
